













































































































import { Component, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import { BuffetEpgItem } from "@/services/apiService/api.types";
import Swiper, { SwiperOptions } from "swiper";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { ChannelsPageGetter } from "@/components/channelsPage/types";
import { mixins } from "vue-class-component";
import { BuffetCategories, Categories } from "@/helpers/constants";
import ChannelCard from "@/components/channelsPage/components/ChannelCard.vue";
import {
  debounce,
  getBreakpoint,
  getEpgDates,
  MediaQuery,
  scrollToPage
} from "@/helpers/utils";
import EpgCard from "@/components/channelsPage/components/EpgCard.vue";
import DateTimeSection from "@/components/DateTimeSection.vue";
import InfoModal from "@/components/channelsPage/components/InfoModal.vue";
import EpgModal from "@/components/channelsPage/components/EpgModal.vue";
import { DailyEpg } from "@/components/overlay/types";
import { BuffetCategoriesFilter } from "@/mixins/BuffetCategoryFilter";
import {
  BuffetFilterType,
  BuffetGetter,
  BuffetMutation
} from "@/components/buffet/types";
import BuffetEpgCard from "@/components/buffet/BuffetEpgCard.vue";
import BuffetHomePage from "@/components/buffet/BuffetHomePage.vue";
import dayjs from "dayjs";
import { NavigationGuardNext, Route } from "vue-router";
import { RouteName } from "@/router/types";
import { LocaleBuffetCategoriesEnum } from "@/plugins/i18n/types";

@Component({
  components: {
    BuffetHomePage,
    BuffetEpgCard,
    DateTimeSection,
    EpgCard,
    ChannelCard,
    InfoModal,
    EpgModal
  }
})
export default class BuffetPage extends mixins(BuffetCategoriesFilter) {
  @Mutation(BuffetMutation.setUpdatedBuffetItems, {
    namespace: Namespace.Buffet
  })
  setUpdatedBuffetItems!: (value: boolean) => void;

  @Mutation(BuffetMutation.setPlayedEpgItemCat, { namespace: Namespace.Buffet })
  setPlayedEpgItemCat!: (category?: BuffetCategories) => void;

  @Mutation(BuffetMutation.setPlayedEpgItemDate, {
    namespace: Namespace.Buffet
  })
  setPlayedEpgItemDate!: (date?: string) => void;

  @Getter(ChannelsPageGetter.GetCardControls, {
    namespace: Namespace.ChannelsPage
  })
  getCardControlsStatus!: boolean;

  @Getter(ChannelsPageGetter.GetPlayedChannelCategory, {
    namespace: Namespace.ChannelsPage
  })
  getPlayedChannelCategory?: Categories | BuffetCategories;

  @Getter(ChannelsPageGetter.GetPlayedChannelIndex, {
    namespace: Namespace.ChannelsPage
  })
  getPlayedChannelIndex?: number;

  @Getter(ChannelsPageGetter.getShowEpgScreen, {
    namespace: Namespace.ChannelsPage
  })
  getShowEpgScreen!: boolean;

  @Getter(ChannelsPageGetter.getShowInfoScreen, {
    namespace: Namespace.ChannelsPage
  })
  getShowInfoScreen!: boolean;

  @Getter(BuffetGetter.getPlayedEpgItemCat, {
    namespace: Namespace.Buffet
  })
  getPlayedEpgItemCat!: BuffetCategories;

  @Getter(BuffetGetter.getPlayedEpgItemDate, {
    namespace: Namespace.Buffet
  })
  getPlayedEpgItemDate!: string;

  @Getter(BuffetGetter.getPlayedEpgItemId, {
    namespace: Namespace.Buffet
  })
  getPlayedEpgItemId!: number | undefined;

  epgDates: DailyEpg[] = [];

  activeSlideIndex = 0;
  dateActiveSlideIndex = 0;
  slidesPerRow = 0;

  categoriesType = Categories;

  swiperOptions: SwiperOptions = {
    slidesPerView: 5,
    spaceBetween: 15
  };

  categorySwiper: Swiper | undefined;
  dateSwiper: Swiper | undefined;

  handleResizeDebounce: () => void = debounce(this.setSlidesPerRow, 50);
  handleSpatialNavDebounce: () => void = debounce(SpatialNavigation.resume, 50);

  filterType = BuffetFilterType;

  scrollFuncRef = scrollToPage;

  LocaleBuffetCategoriesEnum = LocaleBuffetCategoriesEnum;

  BuffetCategories = BuffetCategories;

  async mounted(): Promise<void> {
    await this.setCategories();
    await this.filteredCategoriesFunc();

    this.epgDates = getEpgDates();

    this.$nextTick(() => {
      this.categorySwiper = new Swiper(
        ".swiper_categories",
        this.swiperOptions
      );
      this.dateSwiper = new Swiper(".swiper_dates", this.swiperOptions);

      //required config for header swipers
      this.categorySwiper.on("click", () =>
        this.focusFilterItem(this.filterType.CategoryFilter, true)
      );
      this.categorySwiper.keyboard?.disable();

      this.dateSwiper.on("click", () =>
        this.focusFilterItem(this.filterType.DateFilter, true)
      );
      this.dateSwiper.keyboard?.disable();

      //setting initial values for filters
      if (!this.getPlayedEpgItemCat) {
        this.setPlayedEpgItemCat(
          this.filteredBuffetCategories[this.activeSlideIndex]
        );
      }
      if (!this.getPlayedEpgItemDate) {
        this.setPlayedEpgItemDate(this.epgDates[6].date);
      }
      this.focusFilterItem(BuffetFilterType.CategoryFilter);
      this.focusFilterItem(BuffetFilterType.DateFilter);
    });

    window.addEventListener("resize", this.handleResizeDebounce);
    this.setSlidesPerRow(); //setting initial value

    SpatialNavigation.resume();
  }

  get activeCategoryEpgItems(): BuffetEpgItem[] | undefined {
    if (
      this.buffetCategories[
        this.filteredBuffetCategories[this.activeSlideIndex]
      ]
    ) {
      return this.buffetCategories[
        this.filteredBuffetCategories[this.activeSlideIndex]
      ].epgList;
    }

    return undefined;
  }

  setSlidesPerRow(): void {
    switch (getBreakpoint()) {
      case MediaQuery.sm:
      case MediaQuery.md:
      case MediaQuery.lg:
        this.slidesPerRow = 3;
        break;
      case MediaQuery.xl:
        this.slidesPerRow = 4;
        break;
      case MediaQuery.xxl:
        this.slidesPerRow = 5;
        break;
    }
  }

  async handleFilterActions(
    event: KeyboardEvent,
    filterType: BuffetFilterType
  ): Promise<void> {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        if (
          (this.activeSlideIndex === 0 &&
            filterType === BuffetFilterType.CategoryFilter) ||
          (this.dateActiveSlideIndex === 0 &&
            filterType === BuffetFilterType.DateFilter)
        ) {
          SpatialNavigation.resume();
          SpatialNavigation.focus("#" + this.$route.name);
          return;
        }

        this.slideLeft(filterType);
        //updating epg list to reflect active date
        if (filterType === BuffetFilterType.DateFilter) {
          this.setUpdatedBuffetItems(true);
          await this.setCategories(
            this.epgDates[this.dateActiveSlideIndex].date
          );
          this.filteredCategoriesFunc();
          this.categorySwiper?.update();
          this.setUpdatedBuffetItems(false);
        }
        break;
      case KeySet.KEY_RIGHT:
        this.slideRight(filterType);
        //updating epg list to reflect active date
        if (filterType === BuffetFilterType.DateFilter) {
          this.setUpdatedBuffetItems(true);
          await this.setCategories(
            this.epgDates[this.dateActiveSlideIndex].date
          );
          this.filteredCategoriesFunc();
          this.categorySwiper?.update();
          this.setUpdatedBuffetItems(false);
        }
        break;
      case KeySet.KEY_UP:
        switch (filterType) {
          case BuffetFilterType.CategoryFilter:
            SpatialNavigation.focus("#idDate" + this.dateActiveSlideIndex);
            this.handleSpatialNavDebounce();
            break;
        }
        break;
      case KeySet.KEY_DOWN:
        switch (filterType) {
          case BuffetFilterType.DateFilter:
            SpatialNavigation.focus("#idCat" + this.activeSlideIndex);
            this.handleSpatialNavDebounce();
            break;
          case BuffetFilterType.CategoryFilter: {
            if (this.activeSlideIndex !== 0) {
              if (this.activeSlideIndex === 0 && this.epgDates.length > 0) {
                SpatialNavigation.focus("#" + this.filteredBuffetCategories[1]);
              }
              let epgId = 0;
              if (
                this.activeCategoryEpgItems &&
                this.activeCategoryEpgItems[0]
              ) {
                epgId = this.activeCategoryEpgItems[0].id;
              }

              SpatialNavigation.resume();
              setTimeout(() => {
                SpatialNavigation.focus("#epgItem" + epgId);
              });

              return;
            }

            SpatialNavigation.resume();

            break;
          }
        }
    }
  }

  slideRight(filterType: BuffetFilterType): void {
    switch (filterType) {
      case BuffetFilterType.CategoryFilter:
        if (
          this.activeSlideIndex >= 2 &&
          this.activeSlideIndex <= this.filteredBuffetCategories.length - 3
        ) {
          this.categorySwiper?.slideNext();
        }

        if (this.activeSlideIndex < this.filteredBuffetCategories.length - 1)
          this.activeSlideIndex++;
        SpatialNavigation.focus("#idCat" + this.activeSlideIndex);
        break;
      case BuffetFilterType.DateFilter:
        if (
          this.dateActiveSlideIndex >= 2 &&
          this.dateActiveSlideIndex <= this.epgDates.length - 3
        ) {
          this.dateSwiper?.slideNext();
        }

        if (this.dateActiveSlideIndex < this.epgDates.length - 1)
          this.dateActiveSlideIndex++;
        SpatialNavigation.focus("#idDate" + this.dateActiveSlideIndex);
        break;
    }
  }

  slideLeft(filterType: BuffetFilterType): void {
    switch (filterType) {
      case BuffetFilterType.CategoryFilter:
        if (
          this.activeSlideIndex >= 2 &&
          this.activeSlideIndex <= this.filteredBuffetCategories.length
        ) {
          this.categorySwiper?.slidePrev();
        }

        if (this.activeSlideIndex > 0) this.activeSlideIndex--;
        SpatialNavigation.focus("#idCat" + this.activeSlideIndex);
        break;
      case BuffetFilterType.DateFilter:
        if (
          this.dateActiveSlideIndex >= 2 &&
          this.dateActiveSlideIndex <= this.epgDates.length - 3
        ) {
          this.dateSwiper?.slidePrev();
        }

        if (this.dateActiveSlideIndex > 0) this.dateActiveSlideIndex--;
        SpatialNavigation.focus("#idDate" + this.dateActiveSlideIndex);
        break;
    }
  }
  handleChannelRefocus(event: KeyboardEvent, epgItemIndex: number): void {
    if (!this.getCardControlsStatus) {
      SpatialNavigation.pause();
      switch (keyCodeFinder(event.keyCode)) {
        case KeySet.KEY_LEFT:
          SpatialNavigation.resume();
          if (epgItemIndex % this.slidesPerRow === 0) {
            SpatialNavigation.focus("#" + this.$route.name);
            return;
          }
          SpatialNavigation.focus();
          break;
        case KeySet.KEY_UP:
          if (epgItemIndex < this.slidesPerRow) {
            SpatialNavigation.focus("#idCat" + this.activeSlideIndex);
            this.handleSpatialNavDebounce();
            return;
          }
          SpatialNavigation.resume();
          SpatialNavigation.focus();
          break;
        default:
          SpatialNavigation.resume();
          SpatialNavigation.focus();
          break;
      }
    }
  }

  //for focusing a specific category on click or when refocusing played channels
  async focusFilterItem(
    filterType: BuffetFilterType,
    focus = false
  ): Promise<void> {
    //for compatibility with the click handler and slide refocus logic
    let desiredSlideIndex = 0;
    if (filterType === BuffetFilterType.CategoryFilter) {
      desiredSlideIndex =
        this.categorySwiper?.clickedIndex !== undefined
          ? this.categorySwiper.clickedIndex
          : this.getPlayedEpgItemCat
          ? this.filteredBuffetCategories.indexOf(this.getPlayedEpgItemCat)
          : 0;

      //proper slider positioning
      if (
        desiredSlideIndex > 2 &&
        desiredSlideIndex < this.filteredBuffetCategories.length - 3
      ) {
        this.categorySwiper?.slideTo(desiredSlideIndex - 2);
      }
      if (desiredSlideIndex <= 2) {
        this.categorySwiper?.slideTo(0);
      }
      if (desiredSlideIndex >= this.filteredBuffetCategories.length - 3) {
        this.categorySwiper?.slideTo(this.filteredBuffetCategories.length - 1);
      }

      this.activeSlideIndex = desiredSlideIndex;
      if (focus) SpatialNavigation.focus("#idCat" + this.activeSlideIndex);
    }

    if (filterType === BuffetFilterType.DateFilter) {
      desiredSlideIndex = this.dateSwiper?.clickedIndex
        ? this.dateSwiper.clickedIndex
        : this.getPlayedEpgItemDate
        ? this.epgDates.findIndex((date) =>
            dayjs(date.date).isSame(this.getPlayedEpgItemDate)
          )
        : 6;

      if (
        desiredSlideIndex > 2 &&
        desiredSlideIndex < this.epgDates.length - 3
      ) {
        this.dateSwiper?.slideTo(desiredSlideIndex - 2);
      }
      if (desiredSlideIndex <= 2) {
        this.dateSwiper?.slideTo(0);
      }
      if (desiredSlideIndex >= this.epgDates.length - 3) {
        this.dateSwiper?.slideTo(this.epgDates.length - 1);
      }

      this.dateActiveSlideIndex = desiredSlideIndex;
      if (focus) SpatialNavigation.focus("#idDate" + this.dateActiveSlideIndex);
    }

    //updating epg list to reflect active date
    if (filterType === BuffetFilterType.DateFilter) {
      this.setUpdatedBuffetItems(true);
      await this.setCategories(this.epgDates[this.dateActiveSlideIndex].date);
      this.filteredCategoriesFunc();
      this.categorySwiper?.update();
      this.setUpdatedBuffetItems(false);
    }
  }

  //setting filter values directly to store
  @Watch("activeSlideIndex")
  handleCatChange(newVal: number): void {
    this.setPlayedEpgItemCat(this.filteredBuffetCategories[newVal]);
  }

  @Watch("dateActiveSlideIndex")
  handleDateChange(newVal: number): void {
    this.setPlayedEpgItemDate(this.epgDates[newVal].date);
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext): void {
    if (to.name !== RouteName.Player) {
      this.setPlayedEpgItemDate(this.epgDates[6].date);
      this.setPlayedEpgItemCat(BuffetCategories.Home);
    }
    next();
  }
  beforeDestroy(): void {
    window.removeEventListener("resize", this.handleResizeDebounce);
  }
}
